// extracted by mini-css-extract-plugin
export default {"root":"styles_root__12EkW","link":"styles_link__q8e4Q","active":"styles_active__ZnqEI"};